import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackSendMessageClick } from './tracking';
import { openNewbuildingChat, openNewbuildingChatAfterAuth } from 'shared/actions/chat';
import { IAppState } from 'shared/common/state';
import { selectSource } from 'shared/selectors';
import { getNewbuildingInformation } from 'shared/selectors/newbuildingHeader';
import { getUser } from 'shared/selectors/user';
import { IDeveloperInfoRedesigned } from 'shared/types/developerInfo';
import { INewbuilding } from 'shared/types/newbuildingHeader';
import { callAuthenticationPopup } from 'shared/utils/authentication';

import type { TContactParam } from '@cian/newbuilding-chat-component';

type TUseBuilderChatOpenHandlerParams = {
  placeType: string;
};

export function useBuilderChatOpenHandler({ placeType }: TUseBuilderChatOpenHandlerParams) {
  const dispatch = useDispatch();

  const user = useSelector(getUser);
  const source = useSelector(selectSource);
  const newbuilding = useSelector(getNewbuildingInformation) as INewbuilding | null;
  const developerInfoRedesigned = useSelector(
    (state: IAppState) => state.results.developerInfoRedesigned,
  ) as IDeveloperInfoRedesigned | null;
  const trackedProductId = newbuilding?.id ?? developerInfoRedesigned?.id ?? 0;

  return React.useCallback(
    (newbuildingContact: TContactParam) => {
      trackSendMessageClick(trackedProductId, placeType, source);

      if (!user.isAuthenticated) {
        dispatch(openNewbuildingChatAfterAuth({ newbuildingContact, placeType }));
        callAuthenticationPopup();

        return;
      }

      dispatch(openNewbuildingChat({ newbuildingContact, placeType }));
    },
    [dispatch, placeType, user, trackedProductId, source],
  );
}
